/**
 * Configuración del módulo de registro de Seway Plus Negocios.
 *
 * Sigue la misma convención que src/app.config.js: constantes editadas a mano,
 * porque el .env de este proyecto no es un dotenv válido (usa sintaxis
 * `export const`) y vue-cli nunca lo parsea.
 */

/**
 * Client ID de Google (OAuth 2.0, tipo "Aplicación web") del proyecto de
 * Google Cloud.
 *
 * Mientras esté vacío:
 *  - el botón "Continuar con Google" NO se dibuja,
 *  - no se carga ningún script externo de Google,
 *  - el registro por correo funciona con normalidad.
 *
 * Para activarlo hay que pegar aquí el client ID Y ponerlo también en el
 * backend (.env -> GOOGLE_CLIENT_ID), porque allí se valida el id_token.
 * Los orígenes autorizados en Google Cloud deben incluir la URL del front
 * (por ejemplo http://localhost:8081 y la de producción).
 */
export const GOOGLE_CLIENT_ID = '';

/** URL del SDK de Google Identity Services. Solo se carga si hay client ID. */
export const GOOGLE_SDK_URL = 'https://accounts.google.com/gsi/client';

/** Tamaño máximo del RUT en MB (debe coincidir con config/negocios.php). */
export const RUT_MAX_MB = 5;

/** Extensiones aceptadas para el RUT. */
export const RUT_ACEPTA = '.pdf,.jpg,.jpeg,.png';
